import { Head } from "@inertiajs/react";
import type { MagazineArticle, MagazineInlineContent } from "./_props";

function text(content: MagazineInlineContent[] = []): string {
  return content.map(item => item.type === "link" ? text(item.content) : item.text).join("").replace(/https?:\/\/[^\s<>"']+/g, "");
}
export function MagazineHead({ article }: { article?: MagazineArticle }) {
  const title = article ? `${article.title} | Hairbook Magazine` : "Hairbook Magazine";
  const description = article ? article.bodyBlocks.map(block => text(block.content)).join(" ").replace(/\s+/g, " ").trim().slice(0, 160) : "髪の悩みと地域から、自分に合う美容師・サロンを探せる取材メディア。技術や人柄、サロンのこだわりをご紹介します。";
  const canonical = `https://magazine.hairbook.jp${article ? `/articles/${article.id}/` : "/"}`;
  const params = new URLSearchParams(window.location.search);
  const noindex = article?.isListed === false || article?.isListed === 0 || document.querySelector('meta[name="rails_stage"]')?.getAttribute("content") !== "main" || params.has("draft_key") || !!params.get("q") || !!params.get("tag") || Number(params.get("offset")) > 0;
  const image = article?.eyecatchUrl?.match(/^https:\/\/(blob\.hairbook\.jp|hairbook\.jp)\//) ? article.eyecatchUrl : undefined;
  return <Head title={title}>
    <meta head-key="description" name="description" content={description} />
    <link head-key="canonical" rel="canonical" href={canonical} />
    <meta head-key="robots" name="robots" content={noindex ? "noindex, follow" : "index, follow"} />
    <meta head-key="og:title" property="og:title" content={title} />
    <meta head-key="og:description" property="og:description" content={description} />
    <meta head-key="og:url" property="og:url" content={canonical} />
    <meta head-key="og:type" property="og:type" content={article ? "article" : "website"} />
    <meta head-key="og:site_name" property="og:site_name" content="Hairbook Magazine" />
    {image && <meta head-key="og:image" property="og:image" content={image} />}
  </Head>;
}
